import React, {PropTypes} from 'react';
import Hls from 'hls.js';
import style from './style';

class HLSPlayer extends React.Component {

  static propTypes = {
    value: PropTypes.object
  };

  state = {
    hls: {}
  };

  render() {
    return (
      <div className={style.sixteenNine}>
        <div className={style.content}>
          <video controls style={{width: '100%', height: '100%'}} {...this.props} ref={(videoInput) => { this.videoInput = videoInput; }}/>
        </div>
      </div>
    );
  }

  componentDidMount() {
    let {value} = this.props;
    this.state.hls = new Hls();
    this.state.hls.loadSource(value.url);
    this.state.hls.attachMedia(this.videoInput);
  }

  componentWillUnmount() {
    this.state.hls.destroy();
  }

}

export default HLSPlayer;





// WEBPACK FOOTER //
// ./src/components/HLSPlayer/HLSPlayer.js